import { FC } from "react";
// Utils
import { getLiveStockSubTabs } from "helpers/myLivestock";
import { useStateSpecies, useLivestockTabs, useHasFeature } from "hooks";
// Components
import { AnimalList as AnimalsListOld } from "components/MyLivestock";
import { AnimalsList } from "animals/AnimalsList";
import { EmptyState, Header, PageHeader, PageContent, Spacer, Tabs } from "components";

export const Animals: FC = () => {
  const { active: speciesActive } = useStateSpecies();
  const LIVESTOCK_TABS = useLivestockTabs();
  const speciesActiveName = speciesActive?.name || "Livestock";
  const title = `My ${speciesActiveName}`;
  const subTitle = `View and manage your ${speciesActiveName.toLowerCase()}`;
  const isServerPaginatedAnimalsList = useHasFeature("SERVER_SIDE_PAGINATION_FOR_ANIMALS_LIST");

  return (
    <>
      <PageHeader>
        <Header title={title} subTitle={subTitle} />
        <Tabs tabs={LIVESTOCK_TABS} selectedTab={0} />
        <Tabs tabs={getLiveStockSubTabs()} selectedTab={0} grayBackgroundTabs />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={1} />
        {isServerPaginatedAnimalsList ? (
          <AnimalsList fromPage="livestock" showSelectColumn={true} showAnimalActionButtons={true} />
        ) : (
          <AnimalsListOld noResults={<EmptyState page="ANIMALS" />} />
        )}
      </PageContent>
    </>
  );
};
